export const HTTP_TIMEOUT_ERROR_CODE = 504;
export const HTTP_BAD_REQUEST_ERROR_CODE = 400;

export const GQL_ERROR = "ERROR";
export const GQL_SUCCESS = "SUCCESS";

export const GQL_FETCH_POLICY_NETWORK_ONLY = {
  fetchPolicy: "network-only",
};

export const GQL_FETCH_POLICY_CACHE_AND_NETWORK_ONLY = {
  fetchPolicy: "cache-and-network",
};